import { twMerge } from 'tailwind-merge';
import ConditionalRenderer from '@/components/ui/custom/ConditionalRenderer';
import { QuizAnswer } from '@/models/Answer';
import { AnswerContent } from '@/components/question/view/primitives/shared/AnswerContent';
import { resolveAnswerContentKind } from '@/utils/questions/resolveAnswerContentKind';

type QuizAnswerContentProps = {
  answer: QuizAnswer;
  index: number;
  className?: string;
};

export function QuizAnswerContent({
  answer,
  index,
  className,
}: QuizAnswerContentProps) {
  const letter = String.fromCharCode(index + 65);
  const isText = resolveAnswerContentKind(answer) === 'text';
  const label = isText ? answer.text : answer.altText;

  return (
    <div className={twMerge('flex items-center gap-4', className)}>
      <ConditionalRenderer condition={!isText}>
        <AnswerContent
          answer={answer}
          className="h-16 w-16 rounded object-cover"
        />
      </ConditionalRenderer>
      <span>{`${letter} - ${label ?? ''}`}</span>
    </div>
  );
}
